import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    Typography,
    Divider,
    Grid,
    Chip,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DataProcessingProtocol({
    open,
    onClose,
    markaUnvan = "",
    markaMersisVno = "",
    markaAdres = "",
    markaTemsilciAdSoyad = "",
    markaEposta = "",
    markaTel = "",
}) {
    const Section = ({ title, children, id }) => (
        <Box id={id} sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>{children}</Box>
        </Box>
    );

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
            <Grid item xs={4} sm={3} md={2}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Typography variant="body2">{value}</Typography>
            </Grid>
        </Grid>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{ sx: { borderRadius: 4, p: 0.5 } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 6 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" fontWeight={800}>Veri İşleme Protokolü (DPA)</Typography>
                    <Chip size="small" label={(new Date()).toLocaleDateString("tr-TR")} />
                </Stack>
                <IconButton aria-label="Kapat" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Taraflar */}
                <Section title="Taraflar" id="taraflar">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Alcago (Veri İşleyen)</Typography>
                    <Box sx={{ mb: 2 }}>
                        <InfoRow label="Unvan" value='Alcago Teknoloji Anonim Şirketi ("Alcago")' />
                        <InfoRow label="MERSİS" value="0050117816000001" />
                        <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                        <InfoRow label="E-posta" value="destek@alcago.com" />
                        <InfoRow label="Telefon" value="0539 397 13 63" />
                    </Box>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Marka (Veri Sorumlusu)</Typography>
                    <Box>
                        <InfoRow label="Unvan" value={`${markaUnvan} ("Marka")`} />
                        <InfoRow label="MERSİS/Vergi No" value={markaMersisVno} />
                        <InfoRow label="Adres" value={markaAdres} />
                        <InfoRow label="Temsilci" value={markaTemsilciAdSoyad} />
                        <InfoRow label="E-posta" value={markaEposta} />
                        <InfoRow label="Telefon" value={markaTel} />
                    </Box>
                </Section>

                {/* 1. Amaç ve Kapsam */}
                <Section title="1. Amaç ve Kapsam" id="amac-kapsam">
                    <Typography>
                        İşbu Protokol; 6698 sayılı KVKK ve GDPR hükümlerine uyum sağlanması amacıyla, Marka tarafından sağlanan veya Alcago’nun hizmet sunumu sırasında işlediği kişisel verilerin hangi şartlarda işleneceğini düzenler.
                    </Typography>
                </Section>

                {/* 2. Tanımlar */}
                <Section title="2. Tanımlar" id="tanimlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>Kişisel Veri:</strong> Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi.</li>
                        <li><strong>Veri Sorumlusu:</strong> Kişisel verilerin işleme amaç ve vasıtalarını belirleyen taraf (Marka).</li>
                        <li><strong>Veri İşleyen:</strong> Veri Sorumlusu adına kişisel verileri işleyen taraf (Alcago).</li>
                        <li><strong>Alt İşleyen:</strong> Veri İşleyen’in hizmet aldığı üçüncü kişiler (Sipay, App Prize, affiliate ağları vb.).</li>
                        <li><strong>İhlal:</strong> Yetkisiz erişim, kayıp, ifşa, bozulma veya imha.</li>
                    </ul>
                </Section>

                {/* 3. İşlenecek Veri Kategorileri */}
                <Section title="3. İşlenecek Veri Kategorileri" id="veri-kategorileri">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>Kimlik Verisi:</strong> Kullanıcı adı, takma ad, profil bilgileri.</li>
                        <li><strong>İletişim Verisi:</strong> E-posta, telefon, cihaz ID.</li>
                        <li><strong>Etkileşim Verisi:</strong> Panel aktiviteleri, reklam etkileşimleri, anket yanıtları.</li>
                        <li><strong>İşlem Verisi:</strong> Alışveriş bilgileri, indirim kodu kullanımı, sipariş kayıtları.</li>
                        <li><strong>Teknik Veriler:</strong> IP, cihaz türü, kullanım logları.</li>
                        <li><strong>Rezervasyon/Hizmet Verisi:</strong> Fırsat/lokal hizmet alımlarına ilişkin işlem kayıtları.</li>
                    </ul>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        📌 Kredi kartı verileri işlenmez; yalnızca ödeme kuruluşu (Sipay) tarafından tutulur.
                    </Typography>
                </Section>

                {/* 4. İşleme Amaçları */}
                <Section title="4. İşleme Amaçları" id="amaclar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Kampanya ve paket hizmetlerinin sağlanması.</li>
                        <li>İndirim kodu ve bakiye kullanımlarının takibi.</li>
                        <li>Raporlama, duygu analizi, istatistik üretimi.</li>
                        <li>Satış atfı ve komisyon hesaplamaları.</li>
                        <li>Dolandırıcılığın ve kötüye kullanımın önlenmesi.</li>
                        <li>Yasal yükümlülüklerin yerine getirilmesi.</li>
                    </ul>
                </Section>

                {/* 5. Veri İşleyen’in Yükümlülükleri */}
                <Section title="5. Veri İşleyen’in Yükümlülükleri (Alcago)" id="yukumlulukler">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Verileri yalnızca Marka’nın talimatı doğrultusunda işlemek.</li>
                        <li>Yetkisiz erişim, açıklama veya aktarımı engelleyecek teknik/idari tedbirleri almak.</li>
                        <li>Alt işleyen kullanmadan önce Marka’ya bilgi vermek.</li>
                        <li>Veri ihlali halinde en geç 72 saat içinde yazılı bildirim yapmak.</li>
                        <li>Hizmet sona erdiğinde verileri silmek, anonimleştirmek veya iade etmek.</li>
                    </ul>
                </Section>

                {/* 6. Alt İşleyenler */}
                <Section title="6. Alt İşleyenler" id="alt-isleyenler">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (ödeme altyapısı)</li>
                        <li>App Prize (görev/ödül sistemleri)</li>
                        <li>Affiliate ağları (kampanya komisyon takibi)</li>
                        <li>Bulut hizmet sağlayıcıları (veri barındırma)</li>
                    </ul>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Marka, bu alt işleyenlerin kullanılmasını kabul eder.
                    </Typography>
                </Section>

                {/* 7. Yurt Dışına Aktarım */}
                <Section title="7. Yurt Dışına Aktarım" id="yurt-disi">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Veriler, yurt dışında bulunan sunuculara aktarılabilir.</li>
                        <li>Aktarım KVKK m.9’a uygun veya ilgili kişilerin açık rızası ile yapılır.</li>
                        <li>GDPR kapsamında yeterlilik kararı olan ülkelere veya SCC (Standart Sözleşme Maddeleri) ile aktarım yapılır.</li>
                    </ul>
                </Section>

                {/* 8. Veri İhlali Bildirimi */}
                <Section title="8. Veri İhlali Bildirimi" id="ihlali">
                    <Typography>
                        Kişisel veri ihlali halinde Alcago, derhal ve en geç 72 saat içinde Markaya yazılı bildirim yapar; ihlalin niteliği, etkilenen veri kategorileri, muhtemel sonuçlar ve alınan önlemler açıklanır.
                    </Typography>
                </Section>

                {/* 9. Denetim ve İş Birliği */}
                <Section title="9. Denetim ve İş Birliği" id="denetim">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, makul sürelerde denetim yapabilir.</li>
                        <li>Alcago, Kurul (KVKK) ve ilgili otoritelerden gelen taleplerde Marka ile iş birliği yapar.</li>
                    </ul>
                </Section>

                {/* 10. Süre ve Fesih */}
                <Section title="10. Süre ve Fesih" id="sure-fesih">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Protokol, ana hizmet sözleşmesi süresince yürürlüktedir.</li>
                        <li>Fesihte veriler, Marka talimatına uygun şekilde silinir, iade edilir veya anonimleştirilir.</li>
                    </ul>
                </Section>

                {/* 11. Hukuk ve Yetki */}
                <Section title="11. Hukuk ve Yetki" id="hukuk-yetki">
                    <Typography>Türk Hukuku uygulanır; İstanbul Merkez (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.</Typography>
                </Section>

                {/* 12. Elektronik Kabul */}
                <Section title="12. Elektronik Kabul" id="e-kabul">
                    <Typography>Taraflar, bu Protokolü elektronik ortamda onaylayarak yürürlüğe koymuş sayılır.</Typography>
                </Section>

                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Button variant="outlined" onClick={onClose}>Kapat</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
